// src/pages/Activate/Activate.tsx
import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import LoadingIndicator from '../../components/LoadingIndicator';
import { activateAccount } from '../../services/authService';
import './Activate.css';

const Activate: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleActivate = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token) {
      setMessage('不正なトークンです。');
      return;
    }
    if (password !== confirmPassword) {
      setMessage('パスワードと確認用パスワードが一致しません。');
      return;
    }
    setLoading(true);
    try {
      // activateAccount API を呼び出し、パスワード設定とアクティベーションを完了する処理
      await activateAccount({ token, password });
      setMessage('アクティベーションが完了しました。ログインしてください。');
      // 完了後にログイン画面へリダイレクトする
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      console.error(error);
      setMessage('アクティベーションに失敗しました。');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="activate-page">
      <h1 className="page-title">アカウント有効化</h1>
      {loading && <LoadingIndicator isFullPage={false} />}
      {message && <div className="notification">{message}</div>}
      <form className="activate-form" onSubmit={handleActivate}>
        <div className="form-field">
          <label htmlFor="password">新しいパスワードを入力してください</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="form-field">
          <label htmlFor="confirm-password">パスワード確認</label>
          <input
            id="confirm-password"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <Button type="submit" disabled={loading}>
          {loading ? '処理中...' : 'パスワード登録'}
        </Button>
      </form>
    </div>
  );
};

export default Activate;
